// src/config/env.js
// window.__ENV__ is written by /env.js at container start
const ENV = (window.__ENV__ || {});

// Safe helpers with defaults for local dev
export const API_BASE = (ENV.API_BASE || "http://localhost:8081").replace(/\/$/, "");
export const API_PREFIX = (ENV.API_PREFIX || "/api").startsWith("/")
  ? (ENV.API_PREFIX || "/api")
  : `/${ENV.API_PREFIX || "api"}`;

export const KEYCLOAK_URL =  "https://cognifog-auth.ebosrndportal.com";
export const KEYCLOAK_REALM = ENV.KEYCLOAK_REALM || "cognifog-local";
export const KEYCLOAK_CLIENT_ID = ENV.KEYCLOAK_CLIENT_ID || "cognifog-web";
export const APP_BASE_PATH = ENV.APP_BASE_PATH || "/";
export const BUILD_VERSION = ENV.BUILD_VERSION || "dev";
export const EYE_BASE = ENV.EYE_BASE || "https://cognifog.kentyou.com/eye/rest";
export const EYE_BASIC_AUTH = ENV.EYE_BASIC_AUTH || "Basic Y29nbmlmb2c6Y29nbmlmb2c=";

